export default "__VITE_ASSET__BPIphKKj__"